(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const observer = new MutationObserver(() => {
    document.querySelectorAll('a.jdgm-write-rev-link').forEach((link) => {
      link.removeAttribute('target'); // strips the blank-tab-causing attribute, re-checked on every mutation
      link.classList.add('btn', 'btn--secondary');
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['target'], // catches Judge.me re-adding it if the widget re-renders
  });

  if (!customElements.get('read-more-text')) {
    class ReadMoreText extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('.read-more-content');
        this.button = this.querySelector('.read-more-toggle');
        if (!this.content || !this.button) return;

        // collapsed height comes from the --read-more-height custom property set inline on this element
        this.collapsedHeight = parseFloat(getComputedStyle(this).getPropertyValue('--read-more-height')) || 150;

        this.button.addEventListener('click', this.toggle.bind(this));
        window.addEventListener('resize', this.updateHeight.bind(this));
        this.updateHeight();
      }

      updateHeight() {
        // scrollHeight is always the full, unclipped height regardless of the current max-height
        const fullHeight = this.content.scrollHeight;
        const isTruncated = fullHeight > this.collapsedHeight + 1;
        this.toggleAttribute('data-truncated', isTruncated);

        if (!isTruncated) {
          this.removeAttribute('open');
          this.content.style.maxHeight = '';
          return;
        }

        this.content.style.maxHeight = `${this.hasAttribute('open') ? fullHeight : this.collapsedHeight}px`;
      }

      toggle() {
        const isOpen = this.hasAttribute('open');
        const targetHeight = isOpen ? this.collapsedHeight : this.content.scrollHeight;

        this.content.style.maxHeight = `${targetHeight}px`;
        this.toggleAttribute('open', !isOpen);
        this.button.setAttribute('aria-expanded', String(!isOpen));
      }
    }

    customElements.define('read-more-text', ReadMoreText);
  }

  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-jump-to-accordion]');
    if (!link) return;

    const target = document.querySelector(link.getAttribute('href'));
    if (!target) return;

    e.preventDefault();
    const details = target.querySelector('details');
    if (details) details.open = true;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usps-latori"] && !Shopify.designMode) return;
  try {
    
  class UspBarLatori extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('.usp-bar-latori__slider');
      this.slides = this.querySelectorAll('.slider__item');
      this.dots = this.querySelectorAll('.usp-bar-latori__dot');

      if (!this.dots.length || !this.slides.length || !this.slider) return;

      // The active dot is the slide whose center is closest to the slider's
      // center. An IntersectionObserver (threshold 0.5) used to decide this,
      // but on load it reported several slides at once and the last one won,
      // so the row started on the 3rd dot.
      const updateActive = () => {
        const sliderRect = this.slider.getBoundingClientRect();
        const center = sliderRect.left + sliderRect.width / 2;
        let activeIndex = 0;
        let bestDistance = Infinity;
        this.slides.forEach((slide, i) => {
          const rect = slide.getBoundingClientRect();
          const distance = Math.abs(rect.left + rect.width / 2 - center);
          if (distance < bestDistance) {
            bestDistance = distance;
            activeIndex = i;
          }
        });
        // At either scroll end the edge slide can't reach the center.
        const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
        if (this.slider.scrollLeft <= 1) activeIndex = 0;
        else if (this.slider.scrollLeft >= maxScroll - 1) activeIndex = this.slides.length - 1;
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === activeIndex));
      };
      this.slider.addEventListener('scroll', () => requestAnimationFrame(updateActive), { passive: true });
      updateActive();

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          if (this.slides[i]) {
            this.slides[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        });
      });
    }
  }

  if (!customElements.get('usp-bar-latori')) {
    customElements.define('usp-bar-latori', UspBarLatori);
  }

  } catch(e) { console.error(e); }
})();
})();
